import React from 'react';
import FishSchool from '@/motion/FishSchool';
import OceanSurface from '@/motion/OceanSurface';
import FloatingParticles from '@/motion/FloatingParticles';
import Jellyfish from '@/effects/animals/Jellyfish';

/**
 * OceanBackground — 全站统一深海背景系统
 * 
 * 以 AI 攻略（首页 HeroSection）为视觉基准。
 * 所有非首页页面统一使用此组件，保证全站视觉一致。
 * 
 * 层级（从底到顶）：
 *   z-index 0: 深海蓝底色（由各页面自身 background 提供）
 *   z-index 2: 海面光影（OceanSurface）
 *   z-index 3: 鱼群（FishSchool）
 *   z-index 4: 水母（Jellyfish）
 *   z-index 5: 漂浮颗粒（FloatingParticles）
 *   z-index 10: 页面内容
 * 
 * 用法：
 *   <div className="min-h-screen relative" style={{ background: '...' }}>
 *     <OceanBackground />
 *     <div className="relative z-10">
 *       ...页面内容...
 *     </div>
 *   </div>
 */
const OceanBackground = () => {
  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 1 }}
      aria-hidden="true"
    >
      {/* 海面光影 — 底部呼吸光带 */}
      <OceanSurface />

      {/* 鱼群 — canvas 多层深度 */}
      <FishSchool />

      {/* 水母 — 两只营造景深 */}
      <div className="absolute" style={{ top: '8%', right: '12%', zIndex: 4 }}>
        <Jellyfish size={80} delay={0} duration={35} drift={6} opacity={0.45} />
      </div>
      <div className="absolute" style={{ top: '28%', left: '8%', zIndex: 4 }}>
        <Jellyfish size={55} delay={8} duration={42} drift={10} opacity={0.3} />
      </div>

      {/* 漂浮颗粒 — 缓慢上升 */}
      <FloatingParticles />
    </div>
  );
};

export default OceanBackground;
